import React, { useEffect } from "react";
import tryFirst from "../assets/firstPic.jpg";
import trySecond from "../assets/secondPic.jpg";
import tryThird from "../assets/thirdPic.jpg";
import bgImage1 from "../assets/oil-gas-banner.jpg";
import Carousel from "../components/Carousel";
import Facilities from "./Data";
import AOS from "aos";
import services from "../assets/services.jpg";

function Services() {
  const scrollToTop = () => {
    const contactSection = document.getElementById("navbar");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    AOS.init();
  });

  return (
    <div className="flex flex-col border-black ">
      <div className="w-full flex justify-center items-center h-[496px] relative font-poppins border-black">
        <div
          className="absolute inset-0 "
          style={{
            backgroundImage: `url(${bgImage1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        <div className="flex border-black z-10">
          <h1 className="font-[700] text-white text-4xl ">Services</h1>
        </div>
      </div>

      <div id="ContentContainer" className=" flex p-40 h-screen border-black">
        <div
          className="shadow-2xl flex flex-row border-black"
          data-aos="fade-left"
        >
          <div id="ImageContainer" className="flex w-1/2 ">
            <img
              src={tryFirst}
              id="firstPic"
              className="h-full object-cover"
            ></img>
          </div>

          <div className="flex flex-col justify-center  w-1/2 p-10 gap-10">
            <h1 className="flex border-black  font-poppins font-extrabold text-4xl leading-2">
              Manpower Resources
            </h1>
            <p className="flex border-black  font-poppins font-light text-2xl">
              The inspection and testing team comprises Engineers, Authorized
              Inspectors for pressure vessels, piping, and storage tanks,
              Welding Inspectors with CSWIP and AWS certifications, NDT
              personnel skilled in various methods, Coating Inspectors and
              Technicians, Subsea Inspection Engineers, and a Project Planner,
              forming a diverse and proficient workforce.
            </p>
          </div>
        </div>
      </div>

      <div
        id="ContentContainer"
        className=" bg-[#F5F5F5] p-40 w-full h-auto border-black"
      >
        <div
          className="shadow-2xl flex flex-row h-[548px] border-black"
          data-aos="fade-left"
        >
          <img
            src={trySecond}
            id="firstPic"
            className="h-auto w-1/2 object-cover"
          ></img>

          <div className="flex flex-col justify-center items-center w-1/2 p-10 gap-10">
            <h1 className="flex border-black  font-poppins font-extrabold text-4xl leading-2">
              Integrity Inspection and Nondestructive Testing (NDT)
            </h1>
            <p className="flex border-black  font-poppins font-light text-xl">
              Vision One Sdn. Bhd. provides global integrity inspection and
              nondestructive testing (NDT) services, offering both conventional
              (Radiography, Ultrasonic, Magnetic Particle, Dye/Liquid Penetrant,
              Visual, Eddy Current) and advanced NDT services (Coating
              Inspection, Computerized Radiography, Corrosion Monitoring, Eddy
              Current Array, etc.). Their focus is on analyzing hazards,
              assessing safety risks, and implementing control measures to
              ensure asset serviceability.
            </p>
          </div>
        </div>
      </div>

      <div
        id="ContentContainer"
        className=" bg-white p-40 w-full h-auto border-black"
      >
        <div
          className="shadow-2xl flex flex-row h-[548px] border-black"
          data-aos="fade-left"
        >
          <img
            src={tryThird}
            id="firstPic"
            className="h-auto w-1/2 object-cover"
          ></img>

          <div className="flex flex-col justify-center items-center w-1/2 p-10 gap-10">
            <h1 className="flex border-black  font-poppins font-extrabold text-4xl leading-2">
              Fabrication, Manufacturing, Maintenance and Repair
            </h1>
            <p className="flex border-black  font-poppins font-light text-xl">
              Vision One Sdn. Bhd. designs and manufactures products for the
              global oil and gas industry. Their offerings include process
              pressure vessels, heat transfer equipment, storage facilities, and
              mechanical components. They also provide services like pipeline
              testing, in-situ repair, and concrete mattresses for subsea
              pipeline protection. Their clientele consists of EPCC contractors,
              offshore fabricators, and process package specialists.
            </p>
          </div>
        </div>
      </div>

      <div
        className="flex flex-col gap-10  font-poppins w-full pt-0 p-40 border-black"
        data-aos="fade-up"
      >
        <div className="flex flex-col gap-10 items-center">
          <h1 className="font-[700] text-4xl">List of Facilities We Have</h1>

          <Carousel images={Facilities} />
        </div>

        <div className="flex flex-row  border-black justify-end">
          <button
            onClick={scrollToTop}
            class="text-white bg-gray-900 hover:bg-blue-500 duration-150 font-medium  text-md px-5 py-3"
          >
            <h1 className="text-5xl font">^</h1>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Services;
